import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
  ClassEntity,
  ClassComponentEntity,
  ClassComponentScheduleEntity,
  CourseEntity, UniversityEntity,
  TeachingModeEntity,
  TimeZoneEntity
} from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  classColumn: {
    verticalAlign: 'text-top',
  },
  compColumn: {
    verticalAlign: 'text-top',
  },
  tableTitle: {
    marginLeft: theme.spacing(-1),
  },
}));

//type ClassSelectedHandler = (selected: ClassEntity) => void;

export interface VseApplFormApplClassProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  data?: ClassEntity[],
  teachingModeOptions: TeachingModeEntity[],
  timeZoneOptions: TimeZoneEntity[],
  //getCourse: (seasonID: number, univID: number, termcode: string, code: string) => CourseEntity | undefined,
  getCourse: (code: string) => CourseEntity | undefined,
  getUniversity: (id: number) => UniversityEntity | undefined,
  applscourse?: CourseEntity[];
  //onSelected: ClassSelectedHandler,
}

function getTeachingMode(code: string, props: VseApplFormApplClassProps): string {
  const tm = props.teachingModeOptions.find((e) => e.code === code);
  const tmDescr = (tm === undefined ? code : tm.description);
  return tmDescr;
}

function getTimeZone(code: string, props: VseApplFormApplClassProps): string {
  const tz = props.timeZoneOptions.find((e) => e.code === code);
  const tzDescr = (tz === undefined ? code : tz.description);
  return tzDescr;
}

function renderOtherComponents(props: VseApplFormApplClassProps, classes: ReturnType<typeof useStyles>, comp: ClassComponentEntity, schedules?: ClassComponentScheduleEntity[]) {
  const compSchedules = schedules?.filter((s => {
    return s.classID === comp.classID && s.componentID === comp.componentID;
  }));
  return (
    <TableRow key={`${comp.classID}-${comp.componentID}`}>
      <TableCell className={classes.compColumn}>{comp.componentType}</TableCell>
      <TableCell className={classes.compColumn}> {getTeachingMode(comp.teachingMode, props)} </TableCell>
      <TableCell>
        {compSchedules?.map((s: ClassComponentScheduleEntity) => (
          <Box key={`${comp.classID}-${comp.componentID}-${s.scheduleID}`}>
            {(s.description === null || s.timeZoneCode === null || s.description.trim().length === 0 || s.description.trim() === 'TBC' || s.description.trim() === 'TBA') ?
              (s.description) :
              (clsx(`${s.description}`, `(${getTimeZone(s.timeZoneCode, props)})`))
            }
          </Box>
        ))}
      </TableCell>
    </TableRow>
  );
}

function renderClass(props: VseApplFormApplClassProps, classes: ReturnType<typeof useStyles>, aClass: ClassEntity) {
  const [firstComp, ...otherComps] = aClass.classComponents ? aClass.classComponents : [];
  const firstCompSchedules = aClass.classComponentSchedules?.filter((s => {
    return s.classID === firstComp.classID && s.componentID === firstComp.componentID;
  }));
  return (
    <TableBody key={clsx(`${aClass.classID}`, "det")}>
      <TableRow key={`${firstComp.classID}-${firstComp.componentID}`}>
        <TableCell className={classes.classColumn}>{firstComp.componentType}</TableCell>
        <TableCell className={classes.classColumn}> {getTeachingMode(firstComp.teachingMode, props)} </TableCell>
        <TableCell>
          {firstCompSchedules?.map((s: ClassComponentScheduleEntity) => (
            <Box key={`${firstComp.classID}-${firstComp.componentID}-${s.scheduleID}`}>
              {(s.description === null || s.timeZoneCode === null || s.description.trim().length === 0 || s.description.trim() === 'TBC' || s.description.trim() === 'TBA') ?
                (s.description) :
                (clsx(`${s.description}`, `(${getTimeZone(s.timeZoneCode, props)})`))
              }
            </Box>
          ))}
        </TableCell>
      </TableRow>
      {otherComps.map((comp) => (
        renderOtherComponents(props, classes, comp, aClass.classComponentSchedules)
      ))}
    </TableBody>
  );
}

function renderClassInfo(aClass: ClassEntity, props: VseApplFormApplClassProps) {
  const univ = props.getUniversity(aClass.universityID);
  //const course = props.getCourse(aClass.seasonID, aClass.universityID, aClass.termCode, aClass.courseCode  );
  const course = props.getCourse(aClass.courseCode);
  const courseTitle = course ? course.courseTitle : '';
  const offerUniversityTerm = course?.universityTerm ? course.universityTerm.description : '';
  const offerUniversity = univ ? univ.universityName : '';

  return (
    <Grid container key={clsx(`${aClass.classID}`, "info")}>
      <Grid container key={clsx(`${aClass.classID}`, "row1")}>
        <Grid item xs={12} md={6} >
          <TextField id='offerUniversityName' label='Course Offering University' value={offerUniversity} InputProps={{
            readOnly: true,
          }} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField id='offerTerm' label='Course Offering Term' value={offerUniversityTerm} InputProps={{
            readOnly: true,
          }} />
        </Grid>
      </Grid>
      <Grid container key={clsx(`${aClass.classID}`, "row2")}>
        <Grid item xs={12} md={3}>
          <TextField id='coursecode' label='Course Code' value={aClass.courseCode} InputProps={{
            readOnly: true,
          }} />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField id='className' label='Class' value={aClass.className} InputProps={{
            readOnly: true,
          }} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField id='course' label='Course Title' value={courseTitle} InputProps={{
            readOnly: true,
          }} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export function VseApplFormApplClass(props: VseApplFormApplClassProps) {
  const classes = useStyles();

  return (
    <div className={props.className}>
      {props.data?.map((aClass) => {
        return renderClassInfo(aClass, props);
      })}
      <div className={classes.tableTitle}>
        <Typography variant='subtitle2'>Class Detail</Typography>
      </div >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Component</TableCell>
            <TableCell>Mode of Teaching</TableCell>
            <TableCell>Schedule</TableCell>
          </TableRow>
        </TableHead>
        {props.data?.map((aClass) => {
          return renderClass(props, classes, aClass);
        })}
      </Table>
    </div >
  );
}
